export default class ReportIssueCreation {
  public message: string;
  public reservationExternalId: string;

  constructor(message: string, reservationExternalId: string) {
    this.message = message;
    this.reservationExternalId = reservationExternalId;
  }
}
